import { combineReducers } from "redux";
import { Actions, StoreState } from '../types';
import { getType } from "typesafe-actions";
import * as actions from '../actions';

function secondaryRingerDeviceId(state: string = '', action: Actions): string {
    switch (action.type) {
        case getType(actions.configureSecondaryRinger):
            return action.payload
    }
    return state;
}

export default combineReducers({
    secondaryRingerDeviceId,
})

export function selectSecondaryRingerDeviceId(state: StoreState) {
    return state.janus.devices.secondaryRingerDeviceId
  }
  